module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAAAAAAAAACH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEAAAEALAAAAAAMAAwAAAIYDI5pwe3nogHy0cpgUnp3nF0YBJLj5EEFADs="